import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PinFlowPageRoutingModule } from './pin-flow-routing.module';

import { PinFlowPage } from './pin-flow.page';
import { ComponentsModule } from 'src/app/components/components.module';
import { LocationPickerComponent } from './location-picker/location-picker';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, PinFlowPageRoutingModule, ComponentsModule],
  declarations: [PinFlowPage, LocationPickerComponent],
})
export class PinFlowPageModule {}
